import { canv } from '@/canv/global.js'

export class shapeTrapezoid {

    constructor() {

    }


    fitText(textPart, x, y, width, height, verticalPadding, horizontalPadding) {

        var allowedWidth = width * 4/6 - 2 * horizontalPadding;
        var allowedHeight = height - 2 * verticalPadding;


        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        textPart.updateDims();

        textPart.startX = x + width / 2 - textPart.width / 2;
        textPart.startY = y + textPart.lines[0].textHeight + height / 2 - textPart.height / 2;

        textPart.updateDims();

        return {
            "allowedWidth": allowedWidth,
            "allowedHeight": allowedHeight
        };
    }

    draw(x, y, width, height) {
        canv.ctx.beginPath();
        canv.ctx.moveTo(x + width / 6, y);
        canv.ctx.lineTo(x + width * 5/6, y);
        canv.ctx.lineTo(x + width, y + height);
        canv.ctx.lineTo(x, y + height);
        canv.ctx.lineTo(x + width/6, y);
        canv.ctx.closePath();
    }

    getAvatar(color) {
        return `
        <svg width="87" height="80" viewBox="0 0 87 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M70.481 0H16.4755C15.9972 0 15.5859 0.338635 15.4941 0.807991L0.23322 78.808C0.112379 79.4256 0.585273 80 1.21461 80H85.7419C86.3712 80 86.8441 79.4256 86.7233 78.808L71.4624 0.807988C71.3706 0.338633 70.9593 0 70.481 0Z"
        fill="` + color + `"/>
        </svg>
        `;
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 25;
            height = 25;
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="` + width + `" height="` + height + `" viewBox="0 0 29 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22.3167 1H6.68331C6.20505 1 5.79375 1.33863 5.70192 1.80799L1.23322 24.648C1.11238 25.2656 1.58527 25.84 2.21461 25.84H26.7854C27.4147 25.84 27.8876 25.2656 27.7668 24.648L23.2981 1.80799C23.2063 1.33863 22.795 1 22.3167 1Z" fill="` + fill + `" stroke="` + stroke + `"/>
            </svg>
        `;
    }

}
